import { gql } from '@apollo/client';
import { DIRECTORY_NODE_FIELDS, FILE_NODE_FIELDS } from './fragments';
import { CHECKLIST_ITEM_FIELDS } from 'src/models/bids/BidChecklist/fragments';

export const LOAD_FILES = gql`
  query getLibraryFiles($parentId: String) {
    ls(parentId: $parentId) {
      ... on FileNode {
        ...fileNodeFields
      }
      ... on DirectoryNode {
        ...directoryNodeFields
      }
    }
  }
  ${FILE_NODE_FIELDS}
  ${DIRECTORY_NODE_FIELDS}
`;

export const CREATE_FOLDER = gql`
  mutation createFolder($parentId: String, $name: String!) {
    mkdir(parentId: $parentId, name: $name) {
      ...directoryNodeFields
    }
  }
  ${DIRECTORY_NODE_FIELDS}
`;

export const UPLOAD_FILE = gql`
  mutation uploadFile($name: String!, $parentId: String) {
    uploadFile(name: $name, parentId: $parentId) {
      ...fileNodeFields
      putUrl
    }
  }
  ${FILE_NODE_FIELDS}
`;

export const REMOVE_FOLDER = gql`
  mutation removeFolder($id: String!) {
    rmFolder(id: $id)
  }
`;

export const REMOVE_FILE = gql`
  mutation removeFile($id: String!) {
    rmFile(id: $id)
  }
`;

export const UPDATE_FOLDER = gql`
  mutation updateFolder($id: String!, $parentId: String, $name: String!) {
    updateFolder(id: $id, values: { name: $name, parentId: $parentId }) {
      ...directoryNodeFields
    }
  }
  ${DIRECTORY_NODE_FIELDS}
`;

export const UPDATE_FILE = gql`
  mutation updateFile($id: String!, $parentId: String, $name: String!) {
    updateFile(id: $id, values: { name: $name, parentId: $parentId }) {
      ...fileNodeFields
    }
  }
  ${FILE_NODE_FIELDS}
`;

export const MOVE_FOLDER = gql`
  mutation updateFolder($id: String!, $parentId: String, $name: String!) {
    updateFolder(id: $id, values: { name: $name, parentId: $parentId }) {
      ...directoryNodeFields
    }
  }
  ${DIRECTORY_NODE_FIELDS}
`;

export const MOVE_FILE = gql`
  mutation updateFile($id: String!, $parentId: String, $name: String!) {
    updateFile(id: $id, values: { parentId: $parentId, name: $name }) {
      ...fileNodeFields
    }
  }
  ${FILE_NODE_FIELDS}
`;

export const ATTACH_FILE = gql`
  mutation attachFile($taskId: String!, $fileId: String!) {
    attachFile(input: { taskId: $taskId, fileId: $fileId }) {
      ...checklistItemFields
    }
  }
  ${CHECKLIST_ITEM_FIELDS}
`;

export const DELETE_ATTACHED_FILE = gql`
  mutation removeAttachment($taskId: String!, $fileId: String!) {
    removeAttachment(input: { taskId: $taskId, fileId: $fileId }) {
      ...checklistItemFields
    }
  }
  ${CHECKLIST_ITEM_FIELDS}
`;
